import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

/* Live "design crit feed" — polls active assessments across the studio and shows
   which dimension is being scored right now. */
export default function LiveCritFeed() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/assessments/live");
      setItems(data || []);
    } catch (e) {
      // silently ignore; admin-only endpoints will 403 for designers without live access
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="v-surface" style={{ padding: 20 }} data-testid="live-crit-feed">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span className="v-live-dot" />
          <div className="overline">Live crit feed</div>
        </div>
        <span className="mono" style={{ fontSize: 10, color: "var(--v-text-3)" }}>{items.length} running</span>
      </div>
      <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
        {loading && items.length === 0 && <div className="mono" style={{ fontSize: 11, color: "var(--v-text-3)" }}>Listening…</div>}
        {!loading && items.length === 0 && (
          <div style={{ fontSize: 13, color: "var(--v-text-2)", lineHeight: 1.5 }}>
            No verdicts in progress right now. Start a new assessment and watch it stream here.
          </div>
        )}
        {items.map((a) => (
          <Link
            key={a.assessment_id}
            to={`/assessments/${a.assessment_id}`}
            data-testid={`live-feed-row-${a.assessment_id}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div className="v-surface-flat" style={{ padding: 12, border: "1px solid var(--v-border)", borderRadius: "var(--radius)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <div className="mono" style={{ fontSize: 10, color: "var(--v-text-3)" }}>{a.brand_name || ""}</div>
                <div className="mono" style={{ fontSize: 10, color: "var(--v-accent)" }}>{a.progress?.current ?? 0}/{a.progress?.total ?? 7}</div>
              </div>
              <div style={{ fontSize: 13, marginTop: 4, color: "var(--v-text)" }}>{a.title}</div>
              <div className="mono" style={{ fontSize: 10, marginTop: 4, color: "var(--v-text-2)" }}>
                {a.progress?.current_label ? `→ ${a.progress.current_label}` : "warming up…"}
              </div>
              <div style={{ height: 3, background: "var(--v-border)", marginTop: 8, borderRadius: 2, overflow: "hidden" }}>
                <div style={{
                  height: "100%",
                  width: `${((a.progress?.current || 0) / (a.progress?.total || 7)) * 100}%`,
                  background: "var(--v-gradient)",
                  transition: "width .5s ease",
                }} />
              </div>
              <div className="mono" style={{ fontSize: 10, marginTop: 6, color: "var(--v-text-3)" }}>
                by {a.designer_name || "—"}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
